/* ==========================================================================
   Orifine — bundle savings inside the "Complete The Look" (bought-together)
   section.

   The theme's own total only ever reflects compare-at prices, which Orifine
   doesn't set — so it always rendered "You are saving: Rs. 0.00" and hid it,
   leaving a bland "Total price" with no mention of the tier discount the
   shopper is actually about to get.

   This reads the checked items, applies the same tiers the cart drawer and
   the Shopify automatic discounts use, and states the real number.

   Messaging only. The price cut itself is enforced by the Shopify automatic
   discounts (COMPLETE10 / COMPLETE15 / COMPLETE20).
   ========================================================================== */
(function () {
  'use strict';

  var CFG = window.OrifineBundle || {};
  var TIERS = (CFG.tiers && CFG.tiers.length ? CFG.tiers : [
    { qty: 2, pct: 10 },
    { qty: 3, pct: 15 },
    { qty: 4, pct: 20 }
  ]).slice().sort(function (a, b) { return a.qty - b.qty; });

  function money(paise) {
    var rupees = paise / 100;
    return '₹' + rupees.toLocaleString('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  function tierFor(count) {
    var hit = null;
    for (var i = 0; i < TIERS.length; i++) {
      if (count >= TIERS[i].qty) hit = TIERS[i];
    }
    return hit;
  }

  function nextTier(count) {
    for (var i = 0; i < TIERS.length; i++) {
      if (count < TIERS[i].qty) return TIERS[i];
    }
    return null;
  }

  function readSelection(root) {
    var items = root.querySelectorAll('.product-bought-together-item');
    var count = 0;
    var subtotal = 0;
    for (var i = 0; i < items.length; i++) {
      var cb = items[i].querySelector('.bought-together-checkbox');
      if (cb && !cb.checked) continue;
      var opt = items[i].querySelector('.product-variant-option');
      if (!opt) continue;
      var price = null;
      if (opt.tagName === 'SELECT') {
        var o = opt.options[opt.selectedIndex];
        price = o && o.dataset ? o.dataset.price : null;
      } else {
        price = opt.dataset ? opt.dataset.price : null;
      }
      price = parseInt(price, 10);
      if (isNaN(price)) continue;
      count++;
      subtotal += price;
    }
    return { count: count, subtotal: subtotal };
  }

  function build(root) {
    var host = root.querySelector('.total-product');
    if (!host) return null;
    var el = host.querySelector('.orifine-bt-bundle');
    if (el) return el;

    el = document.createElement('div');
    el.className = 'orifine-bt-bundle';

    // Sit directly under the theme's total, above the submit button
    var anchor = host.querySelector('.bls__total-price');
    if (anchor && anchor.nextSibling) {
      host.insertBefore(el, anchor.nextSibling);
    } else if (anchor) {
      host.appendChild(el);
    } else {
      host.insertBefore(el, host.firstChild);
    }
    return el;
  }

  function render(root) {
    var el = build(root);
    if (!el) return;

    var sel = readSelection(root);
    var tier = tierFor(sel.count);
    var next = nextTier(sel.count);

    if (sel.count === 0) {
      el.innerHTML = '';
      root.classList.remove('orifine-bt-has-bundle');
      return;
    }

    var html = '';

    if (tier) {
      var save = Math.round(sel.subtotal * tier.pct / 100);
      var after = sel.subtotal - save;
      root.classList.add('orifine-bt-has-bundle');

      html += '<div class="obb-badge"><span class="obb-emoji">🎉</span>'
           +  sel.count + ' pieces · ' + tier.pct + '% OFF</div>';
      html += '<div class="obb-prices">'
           +    '<s class="obb-was">' + money(sel.subtotal) + '</s>'
           +    '<span class="obb-now">' + money(after) + '</span>'
           +  '</div>';
      html += '<div class="obb-save">You save ' + money(save) + ' on rhodium pieces — applied automatically at checkout</div>';
      if (next) {
        var need = next.qty - sel.count;
        html += '<div class="obb-next">Add ' + need + ' more piece' + (need === 1 ? '' : 's')
             +  ' to save ' + next.pct + '%</div>';
      }
    } else {
      root.classList.remove('orifine-bt-has-bundle');
      if (next) {
        var need2 = next.qty - sel.count;
        html += '<div class="obb-next obb-next--lead">Add ' + need2 + ' more piece' + (need2 === 1 ? '' : 's')
             +  ' to unlock <strong>' + next.pct + '% OFF</strong></div>';
      }
    }

    el.innerHTML = html;
  }

  function attach(root) {
    if (root.dataset.orifineBundleBound === '1') return;
    root.dataset.orifineBundleBound = '1';

    var run = function () { render(root); };

    root.addEventListener('change', run);
    root.addEventListener('click', function () { setTimeout(run, 60); });

    // The theme rewrites the total on every change — re-render after it does,
    // guarding against the loop our own write would otherwise cause.
    var host = root.querySelector('.total-product');
    if (host && window.MutationObserver) {
      var busy = false;
      var mo = new MutationObserver(function () {
        if (busy) return;
        busy = true;
        setTimeout(function () { render(root); busy = false; }, 0);
      });
      mo.observe(host, { childList: true, subtree: true, characterData: true });
    }

    run();
  }

  function scan() {
    var roots = document.querySelectorAll('.bls__bought-together, #bls__product-bought-together');
    for (var i = 0; i < roots.length; i++) {
      if (roots[i].querySelector('.product-bought-together-item')) attach(roots[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  // The section is injected asynchronously, so keep watching for it.
  if (window.MutationObserver) {
    new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
  }
  document.addEventListener('shopify:section:load', scan);
})();

/* ==========================================================================
   Drawer scroll-edge affordance.
   Adds .is-scroll-end to the scroll container once the list is fully
   scrolled, so the fade in orifine-density.css can drop away instead of
   hovering over the last card forever.
   ========================================================================== */
(function () {
  'use strict';

  function sync(body) {
    var items = body.querySelector('.bls-items');
    if (!items) return;
    var atEnd = items.scrollTop + items.clientHeight >= items.scrollHeight - 4;
    var noScroll = items.scrollHeight <= items.clientHeight + 4;
    body.classList.toggle('is-scroll-end', atEnd || noScroll);
  }

  function bind(body) {
    if (body.dataset.orifineScrollBound === '1') return;
    body.dataset.orifineScrollBound = '1';
    var items = body.querySelector('.bls-items');
    if (!items) return;
    var run = function () { sync(body); };
    items.addEventListener('scroll', run, { passive: true });
    window.addEventListener('resize', run);
    if (window.ResizeObserver) new ResizeObserver(run).observe(items);
    if (window.MutationObserver) {
      new MutationObserver(run).observe(items, { childList: true, subtree: true });
    }
    run();
  }

  function scan() {
    var bodies = document.querySelectorAll('.bls-minicart-body');
    for (var i = 0; i < bodies.length; i++) bind(bodies[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  if (window.MutationObserver) {
    new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
  }
})();
